
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../hooks/useAuthStore";
import LoadingSpinner from "../components/LoadingSppiner";

interface RoleRouteProps {
  requiredAuthorities?: string[];
  requireAll?: boolean;
}

export default function RoleRoute({ 
  requiredAuthorities = [], 
  requireAll = true 
}: RoleRouteProps) {
  const { user, isLoading, isAuthenticated, logout, hasAuthorities } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <LoadingSpinner />
          <p className="text-sm text-gray-500">Vérification de la session...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ path: location.pathname }}
      />
    );
  }
  if (requiredAuthorities.length > 0) {
    const hasAccess = hasAuthorities(requiredAuthorities, requireAll);
    
    if (!hasAccess) {
      return (
        <div className="h-screen flex items-center justify-center bg-gray-100">
          <div className="bg-white shadow-md rounded-lg p-8 max-w-md w-full text-center border border-gray-200">
            <div className="w-16 h-16 mx-auto rounded-full bg-red-100 text-red-600 flex items-center justify-center text-3xl font-semibold">
              !
            </div>
            <h2 className="text-xl font-bold text-gray-900 mt-5">Accès interdit</h2>
            <p className="text-sm text-gray-500 mt-2">
              Vous ne possédez pas les droits nécessaires pour accéder à cette section.
            </p>
            <div className="flex items-center justify-center gap-4 mt-8">
              <button
                onClick={() => navigate(-1)}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-50 hover:bg-gray-100 border border-gray-300 rounded-md shadow-sm transition-colors"
              >
                Retour arrière
              </button>
              <button
                onClick={() => {
                  logout();
                  navigate("/login", { replace: true });
                }}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md shadow-sm transition-colors"
              >
                Déconnexion
              </button>
            </div>
          </div>
        </div>
      );
    }
  }

  return <Outlet />;
}